import { Component, Input, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  PUBLIC_BRAND_ISOTYPE_BLACK_SRC,
  PUBLIC_BRAND_ISOTYPE_WHITE_SRC,
  PUBLIC_BRAND_LOGO_SRC,
  PUBLIC_BRAND_LOGO_WHITE_SRC,
  PUBLIC_BRAND_WORDMARK,
} from 'src/app/core/branding/public-brand';
import { AdminShellModeService } from '@core/shell/admin-shell-mode.service';
import { CoreService } from 'src/app/services/core.service';

export type BrandingVariant = 'full' | 'isotype';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  templateUrl: './branding.component.html',
  styleUrl: './branding.component.scss',
})
export class BrandingComponent {
  private readonly adminShellMode = inject(AdminShellModeService);

  /** Si es false, la marca es solo visual (p. ej. topbar POS). */
  @Input() navigable = true;

  /** `full` = wordmark; `isotype` = solo símbolo (rail compacto). */
  @Input() variant: BrandingVariant = 'full';

  readonly brandWordmark = PUBLIC_BRAND_WORDMARK;
  readonly brandLogoSrc = PUBLIC_BRAND_LOGO_SRC;
  readonly brandLogoWhiteSrc = PUBLIC_BRAND_LOGO_WHITE_SRC;
  readonly isotypeBlackSrc = PUBLIC_BRAND_ISOTYPE_BLACK_SRC;
  readonly isotypeWhiteSrc = PUBLIC_BRAND_ISOTYPE_WHITE_SRC;

  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}

  /**
   * Destino al clic: tenant → `/dashboard`, platform → `/platform`.
   * POS / no navegable → null.
   */
  homeLink(): string | null {
    if (!this.navigable) {
      return null;
    }
    const mode = this.adminShellMode.mode();
    if (mode === 'pos') {
      return null;
    }
    if (mode === 'platform') {
      return '/platform';
    }
    return '/dashboard';
  }
}
